import type {OptionButtonGroupColor} from 'src/design/atoms/OptionButtonGroup';
import type {OptionListEditorColorOption} from 'src/design/molecules/OptionListEditor';
import {stateColorCssVar} from 'src/design/tokens/colors';

/**
 * Single source of truth for the "state color" palette shared by select
 * options (`FormSelectV2`/`DropdownSettings`) and checkbox/switch states
 * (`FormCheckboxV2`/`FormSwitchV2`/`ToggleColorSettings`). Backend allows
 * exactly these four values; `undefined`/anything else means "no color".
 */
export const VALID_OPTION_COLORS: readonly OptionButtonGroupColor[] = [
  'green',
  'red',
  'blue',
  'yellow',
];

export const optionColorSwatches: Record<OptionButtonGroupColor, string> = {
  green: stateColorCssVar('green'),
  red: stateColorCssVar('red'),
  blue: stateColorCssVar('blue'),
  yellow: stateColorCssVar('yellow'),
};

/** Narrows an arbitrary persisted string to a valid palette color, or `undefined`. */
export const toOptionButtonGroupColor = (
  color: string | undefined
): OptionButtonGroupColor | undefined =>
  VALID_OPTION_COLORS.includes(color as OptionButtonGroupColor)
    ? (color as OptionButtonGroupColor)
    : undefined;

/** `OptionListEditor`-shaped color list, for Select-style color pickers in settings panels. */
export const OPTION_COLOR_SELECT_OPTIONS: OptionListEditorColorOption[] = [
  {value: 'green', label: 'Green', swatch: optionColorSwatches.green},
  {value: 'red', label: 'Red', swatch: optionColorSwatches.red},
  {value: 'blue', label: 'Blue', swatch: optionColorSwatches.blue},
  {value: 'yellow', label: 'Yellow', swatch: optionColorSwatches.yellow},
];
